import { Component, Input } from '@angular/core';
import { SlideupDirective } from '../../../directives/animations/slideup.directive';
import { Product } from '../../../models/product';
import { ProductListItem } from '../product-list-item/product-list-item';

@Component({
  selector: 'app-product-list',
  imports: [SlideupDirective, ProductListItem],
  templateUrl: './product-list.html',
  styleUrl: './product-list.scss',
})
export class ProductList {
  @Input({ required: true }) products: Product[] = [];
}
